import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInternet = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_5140_14767)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2362 5.3504C14.7299 0.84605 7.42678 0.846155 2.9216 5.35033L1.50754 3.93596C6.79382 -1.34914 15.3629 -1.34903 20.6501 3.93588L19.2362 5.3504ZM16.3981 8.1872C13.46 5.24952 8.6967 5.24952 5.75862 8.1872L4.3445 6.77289C8.06361 3.05429 14.0931 3.05429 17.8122 6.77289L16.3981 8.1872ZM16.5897 14.1381C17.6154 14.4028 18.5121 15.0684 19.0582 16.0125C20.6032 18.6835 18.6776 22.0255 15.5918 22.0279H6.06438C4.00413 22.026 2.15403 20.7633 1.4024 18.8451M16.5897 14.1381C16.6791 10.4864 13.1084 7.61346 9.42075 8.77214C7.82042 9.27497 6.55216 10.4723 5.94647 12.0039C2.56336 12.0683 0.104038 15.5319 1.4024 18.8451M14.5026 14.7957C15.0906 12.1559 12.6004 9.86949 10.0203 10.6802C8.82277 11.0564 7.91703 12.0429 7.64408 13.2681L7.44115 14.179L6.51845 14.0394C4.22653 13.6927 2.41874 15.9572 3.26452 18.1154C3.71612 19.2679 4.82725 20.0267 6.06533 20.0279H15.5902C17.1362 20.0267 18.1012 18.3523 17.327 17.014C16.9549 16.3706 16.2579 15.9853 15.5151 16.0125L14.221 16.0597L14.5026 14.7957Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5140_14767">
        <rect
          width={22}
          height={22}
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInternet);

export default ForwardRef;
